import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  children: ReactNode;
  /**
   * Where to render (default `<body>`). Portal into an element to inherit its
   * theme scope (`data-theme`) and CSS custom properties.
   */
  container?: Element | DocumentFragment | null;
}

/** Renders children at the end of <body> (sheets, dialogs, menus, toasts), or into `container`. */
export function Portal({ children, container }: PortalProps) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, container ?? document.body);
}
